import React, { Component } from 'react';
import { Wrapper } from './style';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../CurrentLocale';

import loader from '../../assets/images/loader2.gif';

class Loader extends Component {
  render() {
    return (
      <Wrapper>
        <div>
          <FormattedMessage id="loader.loading" />
        </div>
        <div>
          <FormattedMessage id="loader.please_wait" />
        </div>
        <img src={loader} alt={formatMessage({ id: 'loader.loading' })} />
      </Wrapper>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.js